import { IoTimeOutline, IoArrowForward } from "react-icons/io5";
import clsx from "clsx";
import css from "./TariffNoticeModal.module.css";
import ModalCloseIcon from "../../sharedComponents/ModalCloseIcon/ModalCloseIcon";

// Сповіщення про тариф по центру екрана (закінчується термін, ліміти тощо)
export default function TariffNoticeModal({
  title,
  description,
  actionLabel,
  onAction,
  onClose,
  closeLabel = "Закрити",
  icon: Icon = IoTimeOutline,
  variant = "info",
}) {
  return (
    <div
      className={clsx(css.modal, css[variant])}
      role="alertdialog"
      aria-labelledby="tariff-title"
    >
      <ModalCloseIcon onClose={onClose} />

      <span className={css.iconWrap}>
        <Icon className={css.icon} />
      </span>

      <h2 id="tariff-title" className={css.title}>
        {title}
      </h2>
      {description && <p className={css.description}>{description}</p>}

      {actionLabel && (
        <button type="button" className={css.actionBtn} onClick={onAction}>
          {actionLabel}
          <IoArrowForward className={css.actionIcon} />
        </button>
      )}

      <button type="button" className={css.closeBtn} onClick={onClose}>
        {closeLabel}
      </button>
    </div>
  );
}
